import { ActivityList } from "./ActivityList";

export default {
  list: ActivityList,
};
